import { MatPaginatorIntl } from "@angular/material/paginator";

export class SpanishPaginator extends MatPaginatorIntl {
    override itemsPerPageLabel: string = 'Elementos por página'
    override nextPageLabel: string = 'Página siguiente'
    override previousPageLabel: string = 'Página anterior'
    override firstPageLabel: string = 'Primera página'
    override lastPageLabel: string = 'Última página'

    override getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0 || pageSize === 0) {
            return `0 de ${length}`
        }

        const startIndex = page * pageSize;
        const endIndex = Math.min(startIndex + pageSize, length);

        return `${startIndex + 1} – ${endIndex} de ${length}`;
    }
}
